import moment from 'moment';

/** Project start unless installation range is active; then installation window start. */
export function getBaseUnixForLeadTime(values, projectStartUnixOverride) {
  const projectUnix = projectStartUnixOverride ?? values?.start ?? moment().unix();
  if (
    (values.installation_start_date || values.installation_end_date) &&
    values.installation_start_date
  ) {
    return values.installation_start_date;
  }
  return projectUnix;
}

/**
 * From base date + max product lead days, compute { field, finalUnix } for Formik
 * (single `end` vs range `installation_end_date`), preserving a later user preset.
 * Returns null if no products have lead_time.
 */
export function getInstallEndPatchFromLead(values, baseUnix, products) {
  const withLead = (products || []).filter((p) => p?.lead_time > 0);
  if (!withLead.length) return null;
  const highestLeadTime = Math.max(...withLead.map((p) => p.lead_time));
  const requiredUnix = moment.unix(baseUnix).clone().add(highestLeadTime, 'days').unix();
  const useRange = values.installation_start_date || values.installation_end_date;
  const presetUnix = useRange ? values?.installation_end_date : values?.end;
  const finalUnix =
    presetUnix != null && presetUnix !== '' ? Math.max(requiredUnix, presetUnix) : requiredUnix;
  return { field: useRange ? 'installation_end_date' : 'end', finalUnix };
}
